'use client'

import { Cell, Image, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import { ItemShippingDetailsDiscountType } from '../constants'

type Props = {
  deliveryType: ItemShippingDetailsDiscountType
  discountPercentage: number
}

const ShippingDiscountBanner = ({ deliveryType, discountPercentage: percentage }: Props) => {
  const translate = useTranslate('item.shipment_options.discount.title')
  const asset = useAsset('/assets/shipping')

  const getTranslationKey = () => {
    if (deliveryType === ItemShippingDetailsDiscountType.All) return 'all'

    if (deliveryType === ItemShippingDetailsDiscountType.DropOff) return 'drop_off'

    return 'home'
  }

  const iconPath = asset('box-discount.svg', { theme: { dark: 'box-discount-dark.svg' } })

  return (
    <div className="shipping-discount-banner" data-testid="shipping-discount-banner">
      <Cell
        title={
          <Text
            as="h3"
            text={translate(getTranslationKey(), {
              percentage,
              strong: chunks => <strong key={chunks.join('-')}>{chunks}</strong>,
            })}
            type={Text.Type.Subtitle}
            theme="amplified"
          />
        }
        prefix={
          <Image src={iconPath} size={Image.Size.Medium} testId="shipping-discount-banner-icon" />
        }
        theme="transparent"
      />
    </div>
  )
}

export default ShippingDiscountBanner
